import router from '../../../router'
import NavigationBar from '../../../components/navigation-bar/NavigationBar'
import TabBar from '../../../components/tab-bar/TabBar'
import InputButton from '../../../components/input-button/InputButton'
import InputText from '../../../components/input-text/InputText'
import Loader from '../../../components/loader/Loader'
import { SortedTable, SortLink } from 'vue-sorted-table'
import { ScreenLoader } from '../../../utils/loading.util'
import { RegionService, Region } from '../../../services/region.service'

export default {
    name: 'Regions',
    components: {
        NavigationBar,
        TabBar,
        InputButton,
        InputText,
        SortedTable,
        SortLink,
        Loader
    },

    data() {
        return {
            searchValue: '',
            regions: [],
            sortedRegions: [],
            screenLoader: new ScreenLoader()
        }
    },

    mounted() {
        this.getRegions()
    },

    methods: {
        doAdd() {
            router.push(`/settings/regions/new`)
        },

        selectRow(rowId) {
            router.push(`/settings/regions/${rowId}`)
        },

        search() {
            this.sortedRegions = this.regions.filter(region => {
                const foundName = this.propertyContainsValue(region.name)
                const foundLocation = this.propertyContainsValue(region.getLocations())
                
                return foundName || foundLocation
            })
        },

        propertyContainsValue(value) {
            return value ? value.toLowerCase().includes(this.searchValue.toLowerCase()) : false
        },

        clearSearch() {
            this.searchValue = ''
            this.sortedRegions = this.regions
        },

        getRegions: async function() {
            this.screenLoader.start()

            try {
                const regions = await RegionService.getRegions()
                this.handleRegionsResponse(regions)
            }catch(error) {
                this.screenLoader.stopWithError(error)
            }
        },

        handleRegionsResponse(regions) {
            this.regions = regions.map(o => new Region(o))
            this.sortedRegions = this.regions
            this.screenLoader.stop()
        }
    }
}